var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contentProgress',{attrs:{"content":_vm.content,"screen":_vm.screen,"playerInstance":_vm.playerInstance,"isContinueWatch":_vm.isContinueWatch},on:{"playContent":_vm.play,"removeFromContinueData":_vm.remove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }